(() => {
  "use strict";

  /* ========================================================
     VIDALABS — MOTOR DE PROMOCIONES POR LANDING

     Ejemplo:
     /pages/magnesio-ultra-2026?promocion=klaviyo
     ======================================================== */

    console.log('✅ VIDALABS PROMO JS CARGADO');

  if (window.Shopify && window.Shopify.designMode) {
    return;
  }

  const PARAM_NAME = "promocion";
  const STORAGE_PREFIX = "vl_reader_promo_v1:";

  /*
   * ========================================================
   * CAMPAÑAS
   *
   * Para agregar futuras promociones solo hay que añadir
   * otra entrada aquí.
   * ========================================================
   */

  const CAMPAIGNS = {
    klaviyo: {
      discountCode: "VIP10",

      title: "Desbloqueaste tu precio de lector",

      body:
        "Un 10% de descuento exclusivo para quienes me leen todos los días.",

      guarantee:
        "Y como siempre, con 60 días de garantía en tu compra.",

      founder: "Antonio H.",
      founderRole: "Fundador",

      buttonText: "Activar mi descuento",

      barText: "Tu 10% OFF exclusivo termina hoy",
      barCode: "Código VIP10"
    }
  };


  /* ========================================================
     HELPERS
     ======================================================== */

  const normalizePath = (path) => {
    if (!path) return "/";

    let normalized = path.replace(/\/+$/, "");

    return normalized || "/";
  };


  const getStorageKey = (campaignId, path) => {
    return (
      STORAGE_PREFIX +
      encodeURIComponent(campaignId) +
      ":" +
      encodeURIComponent(normalizePath(path))
    );
  };


  const readStorage = (key) => {
    try {
      const value = localStorage.getItem(key);

      return value ? JSON.parse(value) : null;
    } catch (error) {
      console.warn("[VidaLabs Promo] No se pudo leer localStorage.", error);

      return null;
    }
  };


  const writeStorage = (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));

      return true;
    } catch (error) {
      console.warn("[VidaLabs Promo] No se pudo guardar localStorage.", error);

      return false;
    }
  };


  const endOfToday = () => {
    const date = new Date();

    date.setHours(23, 59, 59, 999);

    return date.getTime();
  };


  const pad = (number) => {
    return String(number).padStart(2, "0");
  };


  const currentPath = normalizePath(window.location.pathname);


  /* ========================================================
     BUSCAR CAMPAÑA
     ======================================================== */

  const urlParams = new URLSearchParams(window.location.search);

  const campaignFromUrl = urlParams.get(PARAM_NAME);

  let campaignId = null;
  let config = null;
  let state = null;
  let stateKey = null;


  /*
   * --------------------------------------------------------
   * CASO A
   * Llegó directamente desde una URL promocional.
   * --------------------------------------------------------
   */

  if (
    campaignFromUrl &&
    Object.prototype.hasOwnProperty.call(CAMPAIGNS, campaignFromUrl)
  ) {
    campaignId = campaignFromUrl;
    config = CAMPAIGNS[campaignId];

    stateKey = getStorageKey(campaignId, currentPath);

    state = readStorage(stateKey);

    if (!state) {
      state = {
        campaignId: campaignId,

        landingPath: currentPath,

        firstSeenAt: Date.now(),

        expiresAt: endOfToday(),

        popupSeen: false,

        activated: false
      };

      writeStorage(stateKey, state);
    }

    /*
     * Si vuelve a abrir el enlace promocional otro día,
     * renovamos únicamente el contador visual hasta
     * el final de ese día.
     */

    if (state.expiresAt < Date.now()) {
      state.expiresAt = endOfToday();

      writeStorage(stateKey, state);
    }
  }


  /*
   * --------------------------------------------------------
   * CASO B
   * No viene ?promocion= en la URL, pero queremos comprobar
   * si esta página fue anteriormente la landing original.
   * --------------------------------------------------------
   */

  if (!campaignId) {
    let newestMatch = null;

    try {
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);

        if (!key || !key.startsWith(STORAGE_PREFIX)) {
          continue;
        }

        const candidate = readStorage(key);

        if (!candidate) {
          continue;
        }

        if (normalizePath(candidate.landingPath) !== currentPath) {
          continue;
        }

        if (!CAMPAIGNS[candidate.campaignId]) {
          continue;
        }

        if (
          !newestMatch ||
          candidate.firstSeenAt > newestMatch.state.firstSeenAt
        ) {
          newestMatch = {
            key: key,
            state: candidate
          };
        }
      }
    } catch (error) {
      console.warn(
        "[VidaLabs Promo] No se pudo buscar la campaña guardada.",
        error
      );
    }

    if (newestMatch) {
      stateKey = newestMatch.key;
      state = newestMatch.state;

      campaignId = state.campaignId;
      config = CAMPAIGNS[campaignId];
    }
  }


  /*
   * No hay promoción reconocida para esta página.
   */

  if (!campaignId || !config || !state) {
    return;
  }


  /*
   * SEGURIDAD PRINCIPAL:
   *
   * Los elementos visuales solamente se renderizan
   * en la landing original.
   */

  if (normalizePath(state.landingPath) !== currentPath) {
    return;
  }


  /* ========================================================
     GUARDAR ESTADO
     ======================================================== */

  const saveState = () => {
    writeStorage(stateKey, state);
  };


  /* ========================================================
     APLICAR DESCUENTO
     ======================================================== */

  const applyDiscount = async () => {
    /*
     * Shopify recomienda usar URLs respetando la ruta/local
     * actual de la tienda.
     */

    const shopifyRoot =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

    const endpoint = `${shopifyRoot}cart/update.js`;

    try {
      const response = await fetch(endpoint, {
        method: "POST",

        credentials: "same-origin",

        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },

        body: JSON.stringify({
          discount: config.discountCode
        })
      });

      if (!response.ok) {
        throw new Error(
          `Shopify respondió con status ${response.status}`
        );
      }

      const cart = await response.json();

      state.activated = true;
      state.popupSeen = true;

      saveState();

      /*
       * Evento propio por si más adelante queremos
       * conectar analytics, GTM, Klaviyo, etc.
       */

      document.dispatchEvent(
        new CustomEvent("vl:promo:activated", {
          detail: {
            campaign: campaignId,
            code: config.discountCode,
            cart: cart
          }
        })
      );

      return true;
    } catch (error) {
      console.error(
        "[VidaLabs Promo] Error aplicando descuento vía Ajax.",
        error
      );

      /*
       * FALLBACK:
       *
       * Si por algún motivo cart/update.js falla,
       * utilizamos el mecanismo nativo de Shopify:
       *
       * /discount/VIP10?redirect=...
       */

      state.popupSeen = true;
      state.activated = true;

      saveState();

      const returnUrl =
        window.location.pathname +
        window.location.search +
        window.location.hash;

      const fallbackUrl =
        "/discount/" +
        encodeURIComponent(config.discountCode) +
        "?redirect=" +
        encodeURIComponent(returnUrl);

      window.location.assign(fallbackUrl);

      return false;
    }
  };


  /* ========================================================
     QUITAR MODAL
     ======================================================== */

  const removePopup = () => {
    const overlay = document.querySelector(
      ".vl-reader-promo-overlay"
    );

    if (overlay) {
      overlay.remove();
    }

    document.body.classList.remove(
      "vl-reader-promo-modal-open"
    );
  };


  /* ========================================================
     CINTA
     ======================================================== */

  const showBar = () => {
    if (document.querySelector(".vl-reader-promo-bar")) {
      return;
    }

    const bar = document.createElement("aside");

    bar.className = "vl-reader-promo-bar";
    bar.setAttribute("aria-label", "Promoción exclusiva");

    const codeElement = state.activated
      ? `
        <span class="vl-reader-promo-bar-code">
          ${config.barCode}
        </span>
      `
      : `
        <button
          type="button"
          class="vl-reader-promo-bar-code"
          data-vl-promo-activate-bar
          aria-label="Activar descuento ${config.discountCode}"
        >
          ${config.barCode}
        </button>
      `;

    bar.innerHTML = `
      <div class="vl-reader-promo-bar-inner">

        <span class="vl-reader-promo-bar-text">
          ${config.barText}
        </span>

        <span
          class="vl-reader-promo-bar-separator"
          aria-hidden="true"
        ></span>

        ${codeElement}

        <span
          class="vl-reader-promo-countdown"
          data-vl-promo-countdown
          aria-label="Tiempo restante"
        >
          --:--:--
        </span>

      </div>
    `;

    document.body.insertAdjacentElement(
      "afterbegin",
      bar
    );

    document.body.classList.add("vl-reader-promo-bar-visible");


    /*
     * Si cerró el popup sin activar,
     * Código VIP10 funciona como segundo CTA.
     */

    const barActivateButton = bar.querySelector(
      "[data-vl-promo-activate-bar]"
    );

    if (barActivateButton) {
      barActivateButton.addEventListener(
        "click",
        async () => {
          barActivateButton.disabled = true;

          await applyDiscount();

          /*
           * Si AJAX tuvo éxito y seguimos en esta página,
           * sustituimos botón por texto.
           */

          if (state.activated) {
            const replacement = document.createElement("span");

            replacement.className =
              "vl-reader-promo-bar-code";

            replacement.textContent = config.barCode;

            barActivateButton.replaceWith(replacement);
          }
        }
      );
    }


    /* ======================================================
       COUNTDOWN
       ====================================================== */

    const countdown = bar.querySelector(
      "[data-vl-promo-countdown]"
    );

    const updateCountdown = () => {
      const remaining = Math.max(
        0,
        state.expiresAt - Date.now()
      );

      const totalSeconds = Math.floor(
        remaining / 1000
      );

      const hours = Math.floor(
        totalSeconds / 3600
      );

      const minutes = Math.floor(
        (totalSeconds % 3600) / 60
      );

      const seconds =
        totalSeconds % 60;

      countdown.textContent =
        `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    };

    updateCountdown();

    window.setInterval(
      updateCountdown,
      1000
    );
  };


  /* ========================================================
     POPUP
     ======================================================== */

  const showPopup = () => {
    if (
      document.querySelector(
        ".vl-reader-promo-overlay"
      )
    ) {
      return;
    }

    const overlay = document.createElement("div");

    overlay.className =
      "vl-reader-promo-overlay";

    overlay.innerHTML = `
      <div
        class="vl-reader-promo-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="vl-reader-promo-title"
      >

        <button
          type="button"
          class="vl-reader-promo-close"
          aria-label="Cerrar promoción"
          data-vl-promo-close
        >
          &times;
        </button>

        <div class="vl-reader-promo-inner">

          <h2
            id="vl-reader-promo-title"
            class="vl-reader-promo-title"
          >
            ${config.title}
          </h2>

          <p class="vl-reader-promo-copy">
            ${config.body}
          </p>


          <div class="vl-reader-promo-code-area">

            <span class="vl-reader-promo-code-label">
              Código
            </span>

            <span class="vl-reader-promo-code">
              ${config.discountCode}
            </span>

          </div>


          <p class="vl-reader-promo-guarantee">
            ${config.guarantee}
          </p>


          <p class="vl-reader-promo-signature">

            <strong>
              ${config.founder}
            </strong>

            <span>
              ${config.founderRole}
            </span>

          </p>


          <button
            type="button"
            class="vl-reader-promo-activate"
            data-vl-promo-activate
          >
            ${config.buttonText}
          </button>

        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    document.body.classList.add(
      "vl-reader-promo-modal-open"
    );


    const closeButton = overlay.querySelector(
      "[data-vl-promo-close]"
    );

    const activateButton = overlay.querySelector(
      "[data-vl-promo-activate]"
    );


    /*
     * Cerrar SIN aplicar descuento.
     */

    const closeWithoutActivating = () => {
      state.popupSeen = true;

      saveState();

      removePopup();
      showBar();
    };


    closeButton.addEventListener(
      "click",
      closeWithoutActivating
    );


    /*
     * Click fuera de la tarjeta.
     */

    overlay.addEventListener(
      "click",
      (event) => {
        if (event.target === overlay) {
          closeWithoutActivating();
        }
      }
    );


    /*
     * ESC
     */

    const escListener = (event) => {
      if (event.key !== "Escape") {
        return;
      }

      document.removeEventListener(
        "keydown",
        escListener
      );

      closeWithoutActivating();
    };

    document.addEventListener(
      "keydown",
      escListener
    );


    /*
     * Activar descuento.
     */

    activateButton.addEventListener(
      "click",
      async () => {
        activateButton.disabled = true;

        activateButton.textContent =
          "Activando...";

        const applied =
          await applyDiscount();

        /*
         * Si usamos el fallback nativo,
         * la página va a redirigir y este código
         * ya no necesita continuar.
         */

        if (!applied) {
          return;
        }

        removePopup();

        showBar();
      }
    );


    /*
     * Accesibilidad:
     * mandamos foco al CTA.
     */

    window.setTimeout(() => {
      activateButton.focus();
    }, 150);
  };


  /* ========================================================
     INICIAR EXPERIENCIA
     ======================================================== */

  if (state.popupSeen) {
    showBar();
  } else {
    showPopup();
  }

})();